/* this file is transformed by vux-loader */
/* eslint-disable */
import _classCallCheck from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createClass";
import AMapEngine from './AMapEngine';
import TDTMapEngine from './TDTMapEngine';
import DMapEngine from './DMapEngine';
import store from '@/store';
var MapFactory = /*#__PURE__*/function () {
  function MapFactory() {
    _classCallCheck(this, MapFactory);
  }
  _createClass(MapFactory, null, [{
    key: "create",
    value: function create(containerId, type) {
      var engines = {
        amap: AMapEngine,
        tianditu: TDTMapEngine,
        dmap: DMapEngine
      };
      var mapType = type || store.state.globalStore.mapType;
      var EngineClass = engines[mapType] || TDTMapEngine;
      return new EngineClass(containerId);
    }
  }]);
  return MapFactory;
}();
export { MapFactory as default };